// extracted by mini-css-extract-plugin
export default {"title":"IgkhZbr8r0idP56dBPnn"};